<script setup>
import { computed, provide, toRaw } from 'vue'
import { NodeViewWrapper, nodeViewProps } from '@tiptap/vue-3'
import EditableNode from '@/Components/Inputs/BlockEditor/Extension/Components/EditableNodeWrapper.vue'
import useNodeProps from '@/Composables/useNodeProps'
import { MobileNavigation, TabletNavigation, DesktopNavigation } from '@/Components/Navigation'
import EditNavigation from '../../Modals/EditNavigation.vue'

const props = defineProps({
  ...nodeViewProps,
})

let { items: editableItems } = useNodeProps(props)

provide('elementId', props.node.attrs.id)

const isEditing = computed(() => props.editor.view.editable)

const contentData = computed(() => props.extension.options?.data?.[props.node.attrs.id])

// Note: for display and rendering outside the editor, we will attempt to use
// contentData rather than editable data as it has been computed to contain
// all possible localised urls. if not available (such as in the preview),
// we'll fall back to editable items
const mobileItems = computed(() => contentData.value ? toRaw(contentData.value.items[0]) : editableItems.value)
const tabletItems = computed(() => contentData.value ? toRaw(contentData.value.items[1]) : editableItems.value)
const leftDesktopItems = computed(() => contentData.value ? toRaw(contentData.value.items[2]) : editableItems.value)
</script>

<template>
  <node-view-wrapper>
    <EditableNode v-bind="props">
      <template #tools>
        <EditNavigation v-model:items="editableItems" :editor="editor" />
      </template>
      <template #content>
        <template v-if="isEditing">
          <div v-if="Object.values(editableItems).length === 0" class="text-center">
            <h3 class="mt-2 text-sm font-semibold text-gray-900">No Menu Items</h3>
            <p class="mt-1 text-sm text-gray-500">Edit this element to add menu items.</p>
          </div>
          <div v-else class="relative">
            <div class="absolute inset-0 text-center"></div>
            <DesktopNavigation :items="editableItems" />
          </div>
        </template>
        <template v-else>
          <div class="lg:hidden">
            <MobileNavigation :items="mobileItems" />
          </div>

          <div class="hidden lg:block">
            <DesktopNavigation :items="leftDesktopItems" />
          </div>
        </template>
      </template>
    </EditableNode>
  </node-view-wrapper>
</template>
